<template>
  <div class="ReplyMessage">
    <el-dialog
      :title="mediaList[mediaIndex].title"
      :visible.sync="dialogVisible"
      width="572px"
      :before-close="uploadClose"
      append-to-body
      class="upDialog"
    >
      <div class="uploadContent">
        <div class="label">
          {{ mediaIndex == 0 ? "选择图片(限4张)" : "选择视频(限1个)" }}
        </div>
        <div class="upload">
          <el-upload
            element-loading-text="发送中，请不要关闭"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            action=""
            :file-list="fileList"
            list-type="picture-card"
            :auto-upload="false"
            :limit="mediaIndex == 0 ? 4 : 1"
            :accept="mediaList[mediaIndex].accept"
            ref="upload"
            :on-exceed="exceed"
            :on-change="changeFile"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" v-if="mediaIndex === 0" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                :preview-src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>

                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <div slot="file" v-else slot-scope="{ file }">
              <video
                class="el-upload-list__item-thumbnail"
                :src="file.url"
              ></video>

              <span class="el-upload-list__item-actions">
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handlePlay(file)"
                >
                  <i class="el-icon-video-play"></i>
                </span>
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog width="700px" append-to-body :visible.sync="imgVisible">
            <img width="100%" :src="dialogImageUrl" />
          </el-dialog>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          type="info"
          size="small"
          style="border-radius: 2px"
          @click="uploadClose"
          >取 消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="uploadConfirm"
          :disabled="loading"
          style="border-radius: 2px"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div class="content" ref="content">
      <div class="content-view" ref="contentView">
        <div class="viewMoer" v-if="messageList.length < total">
          <a @click="viewMoer"> 查看更多消息</a>
        </div>
        <div
          :class="msg.UserId ? 'messageLeft' : 'messageRight'"
          v-for="msg in messageList"
          :key="msg.Id"
        >
          <div class="message">
            <div class="sendTime">
              {{ msg.CreateTime }}
            </div>
            <div class="msg-content">
              <div v-if="msg.Type === 0">
                {{ msg.Content }}
              </div>
              <div v-else-if="msg.Type === 1">
                <el-image
                  v-for="(url, index) in msg.Content.split('YHE-SPLIT')"
                  :key="index"
                  :src="url"
                  style="max-width: 100px; margin-right: 10px"
                  :preview-src-list="[url]"
                  fit="contain"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div v-else-if="msg.Type === 2">
                <video
                  :src="url"
                  controls
                  v-for="(url, index) in msg.Content.split('YHE-SPLIT')"
                  :key="index"
                ></video>
              </div>
              <div v-else>当前消息损坏</div>
            </div>
          </div>
        </div>
        <!-- <div class="hr" v-if="snedDisabled">
          <hr />
        </div> -->
      </div>
    </div>
    <div class="text"></div>
    <el-row type="flex" class="toolbar" justify="space-between" align="middle">
      <div class="left">
        <el-input
          :disabled="snedDisabled"
          placeholder="请输入文字..."
          autosize
          type="textarea"
          v-model="desc"
          class="input"
        ></el-input>
        <div class="video">
          <el-tooltip
            class="item"
            effect="dark"
            content="发送图片"
            placement="bottom"
          >
            <div class="el-icon-picture-outline" @click="mediaSend(0)"></div>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="发送视频"
            placement="bottom"
          >
            <div class="el-icon-video-camera" @click="mediaSend(1)"></div>
          </el-tooltip>
        </div>
      </div>
      <el-button
        :type="snedDisabled ? 'info' : 'primary'"
        @click="sendText"
        :disabled="snedDisabled"
        size="mini"
        :style="{
          borderRadius: 0,
          height: '33px',
          width: '60px',
          color: snedDisabled ? '#1D2129' : '#fff',
        }"
        >发送</el-button
      >
    </el-row>
  </div>
</template>

<script>
import { userPostMessage, userChat } from "@/api/userApi";
import { upload } from "@/utils/ossUploading";
export default {
  components: {},
  props: {
    feedbackId: Number,
    UpdateStateData: Object,
  },
  data() {
    return {
      loading: false,
      imgVisible: false,
      fileList: [],
      dialogImageUrl: "",
      disabled: false,
      desc: "",
      page: 1,
      size: 10,
      total: 0,
      dialogVisible: false,
      mediaIndex: 0,
      media: [],
      messageList: [],
      mediaList: [
        {
          title: "发送图片",
          accept: ".png,.jpg,.gif,.jpeg",
        },
        {
          title: "发送视频",
          accept: ".mp4,.ogg,.flv,.avi,.wmv,.rmvb,.mov",
        },
      ],
    };
  },
  computed: {
    snedDisabled() {
      return this.UpdateStateData.Status >= 2;
    },
  },
  watch: {},
  //方法集合
  methods: {
    contentScroll() {
      this.$refs.content.scrollTop = this.$refs.content.scrollHeight;
    },
    changeFile(file, list) {
      // console.log(file,list)
      this.media = list;
    },
    viewMoer() {
      this.page++;
      this.addMessage();
    },
    addMessage() {
      this.userChatFn();
    },
    async userChatFn() {
      let res = await userChat({
        id: this.feedbackId,
        page: this.page,
        size: this.size,
      });
      if (res.data.code === 1000) {
        let data = res.data.data.result;
        data.reverse();
        this.messageList.unshift(...data);
        this.total = res.data.data.total;
      }
    },
    sendText() {
      if (this.desc) {
        this.userPostMessageFn(0, this.desc);
      } else {
        this.$message({
          message: "不能发送空消息",
          type: "error",
        });
      }
    },
    async sendMedia() {
      this.loading = true;
      let urlList = [];
      let i = 0;
      for (let file of this.media) {
        i++;
        let url = await upload(file, this.mediaIndex);
        // console.log(url,file);
        urlList.push(url);
      }
      let type = this.mediaIndex + 1;
      let content = urlList.join("YHE-SPLIT");
      this.loading = false;

      await this.userPostMessageFn(type, content);
    },

    async userPostMessageFn(type, content) {
      let res = await userPostMessage({
        content,
        type,
        feedback_id: this.feedbackId,
      });
      if (res.data.code == 1000) {
        this.initMessage();
        this.userChatFn();

        this.$message({
          type: "success",
          message: "发送成功", //res.data.msg,
        });
      }
    },
    exceed() {
      let message;
      if (this.mediaIndex == 0) {
        message = "每次最多只能发送4张图片";
      } else {
        message = "每次最多只能发送1个视频";
      }
      this.$message({
        message,
        type: "error",
      });
    },
    async uploadConfirm() {
      let { uploadFiles } = this.$refs.upload;
      if (uploadFiles.length <= 0) {
        this.$message.error("请选择要发送的文件");
      } else {
        await this.sendMedia();
        // this.$message({
        //   message: "发送成功",
        //   type: "success",
        // });
        this.uploadClose();
      }
    },
    handlePlay(file) {
      let { uploadFiles } = this.$refs.upload;
      let index = uploadFiles.findIndex((uploadFiles) => {
        return JSON.stringify(uploadFiles) == JSON.stringify(file);
      });
      let video = document.querySelectorAll(".upload video");

      video[index].paused === true ? video[index].play() : video[index].pause();
    },

    initMessage() {
      this.page = 1;
      this.messageList = [];
      this.desc = "";
    },
    uploadClose() {
      this.$refs.upload.uploadFiles.length = 0;
      // console.log(this.$refs.upload.uploadFiles);
      this.dialogVisible = false;
      this.loading = false;
    },
    handleRemove(file) {
      let { uploadFiles } = this.$refs.upload;
      this.$refs.upload.uploadFiles = uploadFiles.filter((uploadFiles) => {
        return JSON.stringify(uploadFiles) != JSON.stringify(file);
      });
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    mediaSend(index) {
      if (this.snedDisabled) {
        return;
      }
      this.mediaIndex = index;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(res, file) {
      this.media = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }

      return true;
    },
  },
  created() {
    this.addMessage();
  },
  mounted() {
    let elementResizeDetectorMaker = require("element-resize-detector");
    let erd = elementResizeDetectorMaker();
    erd.listenTo(this.$refs.contentView, (element) => {
      this.contentScroll();
    });
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
};
</script>
<style lang="less">
.upDialog {
  .el-dialog__body {
    border: 1px solid #e5e6eb;
    border-left: 0;
    border-right: 0;
  }
  .el-dialog__header {
    text-align: center;
    span {
      font-weight: 500;
      font-size: 16px;
      color: #1d2129;
      line-height: 24px;
      font-style: normal;
    }
  }
  .uploadContent {
    // display: flex;
    .label {
      font-size: 14px;
      line-height: 1.5em;
      margin-bottom: 10px;
    }
    .upload {
      // flex: 1;
      .el-upload--picture-card,
      .el-upload-list__item {
        width: 100px;
        height: 100px;
        line-height: 98px;
      }
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
}

.ReplyMessage {
  height: 100%;
  display: flex;
  flex-direction: column;
  // padding: 20px 20px 50px;
  padding: 0;
  box-sizing: border-box;
  border-top: 1px solid #ccc;

  .left {
    margin-right: 10px;
    flex: 1;
  }
  .content {
    flex: 1;
    // border-radius: 5px;
    border-bottom: 1px solid #e5e6eb;
    margin: 0;
    overflow: auto;
    padding: 15px;
    .hr {
      margin-top: 50px;
      margin-bottom: 100px;
    }
    .viewMoer {
      text-align: center;
      cursor: pointer;
    }
    .message {
      max-width: 100%;
      .sendTime {
        margin-top: 0;
        margin-bottom: 10px;
        color: #1d2129;
        font-size: 14px;
      }
    }
    .messageLeft,
    .messageRight {
      margin-bottom: 10px;
      max-width: 100%;
      display: flex;
      flex-wrap: wrap;
      .msg-content {
        padding: 5px 10px;
        border-radius: 4px;
      }
    }
    .msg-content {
      text-align: left;
      div {
        word-wrap: break-word;
        word-break: normal;
        video {
          max-width: 80%;
          max-height: 300px;
        }
      }
    }
    .messageLeft {
      text-align: left;
      justify-content: flex-start;
      .msg-content {
        background-color: #f2f3f5;
        color: #1d2129;
      }
    }
    .messageRight {
      display: flex;
      text-align: right;
      justify-content: flex-end;
      .msg-content {
        background-color: #165dff;
        color: #fff;
      }
    }
  }

  .toolbar {
    margin: 10px;
    .left {
      position: relative;
      .input textarea {
        background: #f2f3f5;
        border-radius: 2px 2px 2px 2px;
        border: 0;
      }
    }
  }
  .video {
    position: absolute;
    top: 5px;
    right: 5px;
    font-size: 22px;
    display: flex;
    align-items: center;
    cursor: pointer;
    // margin-bottom: 10px;
    max-width: 500px;
    div:nth-of-type(n + 2) {
      margin-left: 10px;
      font-size: 26px;
    }
  }
}
</style>
